const IconButtonSecondary = ({ children, ...others }) => {
  return (
    <button
      type="button"
      {...others}
      className="p-2 border border-secondaryText rounded-xl text-secondaryText hover:bg-secondaryHover"
    >
      {children}
    </button>
  );
};

export default IconButtonSecondary;
